// Máscara e formatação de CPF/CNPJ compatíveis com a IN RFB nº 2.229/2024:
// CPF continua 11 dígitos numéricos.
// CNPJ tem 14 caracteres: 12 alfanuméricos [A-Z0-9] + 2 dígitos verificadores numéricos.
// Substitui TextFormats.cpfCnpjMask do @mandae/ng-utils, cuja máscara é numérica.

const DIGIT = /\d/;
const ALPHANUMERIC = /[A-Za-z0-9]/;

const CPF_MASK: (RegExp | string)[] = [
  DIGIT, DIGIT, DIGIT, '.', DIGIT, DIGIT, DIGIT, '.', DIGIT, DIGIT, DIGIT, '-', DIGIT, DIGIT,
];

const CNPJ_MASK: (RegExp | string)[] = [
  ALPHANUMERIC, ALPHANUMERIC, '.',
  ALPHANUMERIC, ALPHANUMERIC, ALPHANUMERIC, '.',
  ALPHANUMERIC, ALPHANUMERIC, ALPHANUMERIC, '/',
  ALPHANUMERIC, ALPHANUMERIC, ALPHANUMERIC, ALPHANUMERIC, '-',
  DIGIT, DIGIT,
];

function sanitize(value: string): string {
  return (value || '').replace(/[^A-Za-z0-9]/g, '');
}

// Função de máscara aceita pelo angular2-text-mask: recebe o valor bruto digitado
// e devolve o array de matchers correspondente. Trocamos para CNPJ_MASK assim que
// detectarmos qualquer letra (CPF é estritamente numérico) ou que o usuário
// ultrapassar 11 caracteres — caso contrário a máscara de CPF bloquearia a
// digitação da primeira letra de um CNPJ alfanumérico.
export function cpfCnpjMask(rawValue: string): (RegExp | string)[] {
  const raw = rawValue || '';
  const hasLetters = /[A-Za-z]/.test(raw);
  const clean = sanitize(raw);
  return hasLetters || clean.length > 11 ? CNPJ_MASK : CPF_MASK;
}

// Formata um valor (sem separadores) para exibição. Aceita 11 chars (CPF) ou
// 14 chars (CNPJ alfanumérico). Para tamanhos diferentes, devolve o valor original.
export function formatCpfCnpj(value: string): string {
  if (!value) {
    return '';
  }

  const clean = sanitize(value).toUpperCase();

  if (clean.length === 11) {
    return `${clean.substr(0, 3)}.${clean.substr(3, 3)}.${clean.substr(6, 3)}-${clean.substr(9, 2)}`;
  }

  if (clean.length === 14) {
    return `${clean.substr(0, 2)}.${clean.substr(2, 3)}.${clean.substr(5, 3)}/${clean.substr(8, 4)}-${clean.substr(12, 2)}`;
  }

  return value;
}
